import {
  makeStyles,
  Container,
  Modal,
  Grid,
  Typography,
} from "@material-ui/core";
import { ButtonPrimary } from "../components-atoms";

export const DeliveryAlreadyProcessedModal = (props: any) => {
  const classes = useStyles();
  return (
    <Modal
      open={props.visible}
      onClose={props.onClose}
      aria-labelledby="This delivery has already been processed"
      className={classes.modal}
    >
      <Container className={classes.modalContainer}>
        <Grid container spacing={1}>
          <Grid item>
            <Typography variant="h6" component="h6" color="textPrimary">
              This delivery has already been processed
            </Typography>
          </Grid>
          <Grid item className={classes.content}>
            <Typography variant="body2" component="p" color="textPrimary">
              This delivery has already been processed by another user. Please refresh the page to see the latest status.
            </Typography>
          </Grid>
          <Grid item container xs={12} justifyContent="flex-end">
            <ButtonPrimary
              onClick={() => props.onClose()}>
              OK
            </ButtonPrimary>
          </Grid>
        </Grid>
      </Container>
    </Modal>
  );
};
const useStyles = makeStyles(() => ({
  modal: { alignItems: "center", justifyContent: "center" },
  modalContainer: {
    width: "480px",
    backgroundColor: "white",
    boxShadow:
      "0px 6px 36px rgba(0, 0, 0, 0.15), 0px 2.21728px 14.2392px rgba(0, 0, 0, 0.111884), 0px 0.93179px 6.99399px rgba(0, 0, 0, 0.0997219), 0px 0.37078px 3.36556px rgba(0, 0, 0, 0.0894965), 0px 0.120827px 1.42249px rgba(0, 0, 0, 0.0753326), 0px 0.0225271px 0.422798px rgba(0, 0, 0, 0.0508791)",
    borderRadius: "20px",
    padding: "24px",
    margin: "0",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
  content: {
    padding: "12px 0 24px 0 !important"
  }
}));
